import { useEffect, useCallback, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Table, Title } from "components";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { getStores } from "redux/slices/Stores";
import { getPreferredBrands, updatePreferredBrandField, deletePreferredBrand, cleanPreferredBrands } from "redux/slices/PreferredBrands";

export function PreferredBrands() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const preferredBrands: any = useAppSelector((state: RootState) => state.preferredBrands);
	const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const user = useAppSelector((state: RootState) => state.logedinUser);

	useEffect(() => {
		dispatch(getPreferredBrands({}));
		dispatch(cleanPreferredBrands());
		dispatch(getStores({ storeGroupIds: [currentStoreGroupId] }));
	}, []);

	const columns = [
		{
			Header: "Name",
			accessor: "name",
			defaultCanSort: true,
			width: 1000,
			Cell: (row: any) => user.permissions.preferredBrands.canUpdate ? <Link to={`/app/preferred-brand/${row.cell.row.original.id}`}>{row.value}</Link>: <>{row.value}</>,

		},
	];

	const selectedRows = useCallback((pageIndex:any) => {
		dispatch(updatePreferredBrandField({ key: "selectedRows", value: pageIndex }));
	}, []);

	function handleDelete() {
		let preferredBrandIds = preferredBrands.selectedRows.map((row: any) => preferredBrands.table[row].id );
		dispatch(deletePreferredBrand(preferredBrandIds)).then(() => {
			dispatch(getPreferredBrands({}));
		});
	}

	return (
		<>
			<Title pageTitle="Preferred Brands" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										disableExport={true}
										columns={columns}
										data={preferredBrands.table}
										selectedRows={selectedRows}
										errors={preferredBrands.error}
										loading={preferredBrands.loading}
										reloadTableRows={() => dispatch(getPreferredBrands({}))}								
										addNewRow={user.permissions.preferredBrands.canCreate ? () => navigate("/app/preferred-brand/new") : undefined }
                                    	removeRows={user.permissions.preferredBrands.canDelete ? handleDelete : undefined}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}